import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { withTranslation } from '../../ChildrenContext';

// Legacy version used router.getCurrentLocation() (react-router v4/v5 prop injected by HOC).
// In the unified app (react-router-dom v6), router is never provided to route elements.
// useLocation() is the correct v6 equivalent and provides the same location.state.
const AuthorisationErrorPage = ({ t }) => {
    const staticNames = (t && t.errorPage && t.errorPage.authorisationError) || {};
    const location = useLocation();
    const state = location.state || {};

    return (
        <div className="notfound text-center">
            <h1>401</h1>
            <h3 className="font-bold">{staticNames.title}</h3>
            <div className="error-desc">
                {state.message}
            </div>
        </div>
    );
};

AuthorisationErrorPage.propTypes = {
    t: PropTypes.object
};

export default withTranslation(AuthorisationErrorPage);
